// extracted by mini-css-extract-plugin
export default {"cta":"jaa","grey":"kaa","dark":"laa","chip":"maa","card":"naa","nonclickable":"oaa","top":"paa","left":"qaa","span":"raa","name":"saa"};
    if(module.hot) {
      // 1730991512972
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  